'use client'
import { memo, useMemo, type FC } from 'react'
import { motion, type Variants } from 'motion/react'
import { LANG } from '@/utils'
import Link from 'next/link'
import { useSession } from '@/hooks'

type Props = {
  data: Array<{
    logo: { src: string },
    slug: { [key: string]: string }
  }>
}

const getLogo = (data:Props['data'], isUserLoggedIn: boolean) => data.map((item, idx) =>  {
  const { logo, slug } = item
  const slugValue = slug?.[LANG]
  return (
    <motion.article key={`brand-${slugValue}-${idx}`} className='brand' variants={logoVariants} initial='initial' animate='animate' exit='exit' custom={idx}>
      <Link href={`/${isUserLoggedIn ? 'shop' : 'catalog'}/brand/${slugValue}`} passHref>
        <motion.figure variants={logoVariants}>
          { /* eslint-disable-next-line @next/next/no-img-element */}
          <img src={logo?.src} alt='Brand logo' />
        </motion.figure>
      </Link>
    </motion.article>
  )
})

export const Logos:FC<Props> = memo(({ data }) => {
  const { user } = useSession()
  const Logos = useMemo(() => getLogo(data, !!user), [data, user])
  return (
    <>
      {Logos}
    </>
  )
})

const logoVariants: Variants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      delay: index * 0.1,
      ease: 'easeOut'
    }
  })
}

